import { useState, useEffect } from 'react';
import { ExperienceApi } from '@apply/api';
import { applicationInsights } from '../../ApplicationInsights';
import { useSelector } from 'react-redux';
import { BfiDataGrid, Column } from '../../common/SharedComponents';
import { GridSettingType } from '@apply/constants';
import store, { ruleActions } from '@apply/adminStore';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil } from '@fortawesome/free-solid-svg-icons';
import { faEye } from '@fortawesome/free-regular-svg-icons';
import { PermissionType } from '@apply/constants';
import { hasPermission } from '@apply/ui';

const SupplementalRulesTable = ({ gridStore }) => {
    const searchState = useSelector((state) => state.searchState);
    const experienceApi = new ExperienceApi.ExperienceApi(applicationInsights);

    const [dataStore, set_dataStore] = useState(gridStore?.store);

    const { dispatch } = store;

    const dataFunction = async (criteria) => {
        return await experienceApi.getSupplementalRules(criteria);
    };

    useEffect(() => {
        if (gridStore) {
            gridStore.setOnLoad('id', dataFunction, searchState?.searchText?.adminUser);
            set_dataStore(gridStore.store);
        }
    }, [gridStore]);

    const onCellDblClick = (e) => {
        dispatch(
            ruleActions.setSupplementalRuleModal({
                supplementalruleModal: {
                    isOpen: true,
                    supplementalRuleId: e.data.id,
                },
            })
        );
    };

    const onActionCellRender = (e) => {
        return (
            <button
                id='editRule'
                className='gridButton'
                title='Edit Rule'
                onClick={(event) => onCellDblClick(e)}
            >
                <FontAwesomeIcon icon={hasPermission(PermissionType.ExperienceConfigurator) ? faPencil : faEye} />
            </button>
        );
    };

    return (
        <BfiDataGrid
            gridType={GridSettingType.ExperienceSupplementalRules}
            dataStore={dataStore}
            applicationInsights={applicationInsights}
            width={'100%'}
        >
            <Column
                dataField='questionText'
                name='questionText'
                caption='Question'
            />
            <Column
                dataField='credits'
                caption='Credits'
                dataType='string'
            />
            <Column
                alignment='center'
                cellRender={onActionCellRender}
                width={50}
                allowReordering={false}
                allowSorting={false}
                allowResizing={false}
            />
        </BfiDataGrid>
    );
};

export default SupplementalRulesTable;
